import {useState, useEffect, useCallback, useRef} from '@wordpress/element';
import {getSetting} from '@woocommerce/settings';
import {useLoadPayPalScript} from "../../hooks";
import {useCreateFastlane, useProcessFastlane} from "./hooks";
import {FastlaneModal} from '../../components';

export default function ExpressPaymentComponent({data, ...props}) {
    const {
        billing,
        cartData,
        shippingData,
        setExpressPaymentError
    } = props;

    const {
        billingAddress
    } = billing;

    const {
        email
    } = billingAddress;

    const [buttonRef, setButtonRef] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const resolveRef = useRef(null);
    const promiseRef = useRef(null);
    const queryParams = getSetting('paypalQueryParams');

    const openFastlaneModal = useCallback(() => {
        promiseRef.current = new Promise(resolve => {
            resolveRef.current = resolve;
        });
        setOpenModal(true);
        return promiseRef.current;
    }, []);

    const onClose = useCallback((skip = false) => {
        setOpenModal(false);
        if (!skip) {
            resolveRef.current(null);
        }
    }, []);

    const onTokenize = useCallback((data) => {
        resolveRef.current(data);
    }, []);

    const paypal = useLoadPayPalScript(queryParams);

    const fastlane = useCreateFastlane({paypal});

    const {
        onClick,
        processing
    } = useProcessFastlane({
        i18n: data.i18n,
        email,
        onError: setExpressPaymentError,
        fastlane,
        shippingData,
        openFastlaneModal
    });


    return (
        <>
            <button
                id="wc-ppcp-fastlane-checkout"
                className="wc-ppcp-fastlane-button"
                ref={setButtonRef}
                disabled={openModal || processing}
                onClick={onClick}>
                <img className={'wc-ppcp-fastlane-icon'} src={data.icon_url}/>
            </button>
            <FastlaneModal
                i18n={data.i18n}
                open={openModal}
                onClose={onClose}
                fastlane={fastlane}
                onTokenize={onTokenize}
                shippingData={shippingData}/>
        </>
    );
}